import { render, staticRenderFns } from "./RedeemLogTable.vue?vue&type=template&id=01aac8bc&scoped=true"
import script from "./RedeemLogTable.vue?vue&type=script&lang=js"
export * from "./RedeemLogTable.vue?vue&type=script&lang=js"
import style0 from "./RedeemLogTable.vue?vue&type=style&index=0&id=01aac8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aac8bc",
  null
  
)

export default component.exports